import { Navigate } from 'react-router-dom';
import { useAiEntitlements } from '../hooks/useAiEntitlements';

export default function AiSupervisoryReviewProtectedRoute({ children, fallbackPath = '/admin' }) {
  const { aiSupervisoryReview, loading } = useAiEntitlements();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-b-2 border-teal-600" />
          <p className="text-gray-600 dark:text-gray-400">Verifying AI seat access...</p>
        </div>
      </div>
    );
  }

  if (!aiSupervisoryReview) return <Navigate to={fallbackPath} replace />;
  return children;
}
